import React, { FunctionComponent as FC, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../state';
import { State } from '../../../../state'; 
import _ from 'lodash';
import './index.scss';

import { InteractionTypes } from '../../../../types/data'; 


interface ContextMenuProps {
}

const ContextMenu: FC<ContextMenuProps> = (props) => {
  const { } = props

  const dispatch = useDispatch()
  const {
    getMainViewData,
    updateMainViewLoading,
    updateFieldLevelRange, 
  } = bindActionCreators(actionCreators, dispatch)

  const [isFolded, setIsFolded] = useState<boolean>(true)
  const toggleFold = () => {
    setIsFolded(!isFolded);
  }

  // data reducer
  const grantIDList: string[] = useSelector((state: State) => state.dataReducer?.grantIDList) as string[]

  // ui reducer
  const fieldLevelRangeRaw: InteractionTypes.UIParamFieldLevelRangeDict = useSelector((state: State) => state.uiReducer?.fieldLevelRange) as InteractionTypes.UIParamFieldLevelRangeDict
  const contextMenuImpactEntity: string = useSelector((state: State) => state.uiReducer?.contextMenuImpactEntity) as string
  const isShowContextMenu: boolean = useSelector((state: State) => state.uiReducer?.isShowContextMenu) as boolean
  const contextMenuPosition: { left: number, top: number } = useSelector((state: State) => state.uiReducer?.contextMenuPosition) as { left: number, top: number }

  // set variables 
  const contextMenuOpacity: number = (isShowContextMenu) ? 1 : 0
  
  // const updateMainView = async () => {
  //   try {
  //     const result = await getMainViewData(fieldLevelRange, grantIDList)

  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     updateMainViewLoading(false)
  //   }
  // }

  // event handlers
  const handleMouseOnClick = (e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const impactEntity: string = parts[0];
    const fieldLevel: string = parts[1];
    // console.log('id: ', id)
    // console.log('click impactEntity: ', impactEntity, fieldLevel)

    // clean up all data in mainview, re-calculate data from backend 
    // Method 1: 点击整个eneity group的时候，选focused layer。globally计算L0-focused layer的global topK fields
    // 这种情况下，grant_id_list不变，只是变fieldLevelRange，然后重新fetch mainview数据
    let fieldLevelRange: InteractionTypes.UIParamFieldLevelRangeDict = _.cloneDeep(fieldLevelRangeRaw)
    const levelNum = +fieldLevel[1]
    fieldLevelRange[impactEntity] = _.range(levelNum + 1).map((level) => `L${level}`)
    // console.log('updated fieldLevelRange: ', fieldLevelRange, levelNum)
    updateFieldLevelRange(fieldLevelRange)

    // 【TODO】Method 2: 右键某个field node的时候，展开这个field node的下一层信息。没有hierarchy结构
    // 暂时不做了。因为case 1的阿尔兹海默症已经找到案例了（Notion的Evaluation那一页）
    // 后端逻辑
    // (1) 根据selected field node, filter新的grant_id_list (有产生这个impact的grant_id_list) 
    // (2) 重新计算grantFieldNode + 这个impact type下、这个field code的下一层 topK fields (就这一层，没有hierarchy结构)
    // (3) 只返回(2)的数据。其他Impact entity不需要计算
    // 前端注意
    // (1) 保留之前右上角选中的所有impact type entity, 并保留entity type graph的node position不变
    // (2) 画新的数据的时候，所有bubble treemap还是在原来的位置，只是:
    //     a. 剩下field缩小为2个entity type graph node (可点击重新展开)
    //     b. 只更新这个impact entity下的bubble treemap (还是对其他entity type做假的数据节点，只是根节点value=0)
  }

  // component elements
  let focusedLevelDivElementList: JSX.Element[] = []
  if (contextMenuImpactEntity === 'paper') {  // L0-L4 
    focusedLevelDivElementList = ['L0', 'L1', 'L2', 'L3', 'L4'].map((level, index) => {
      return (
        <div key={index} id={`paper-${level}`} className='option-div'
              onClick={(e) => {
                const id = e.currentTarget.id 
                handleMouseOnClick(e as unknown as MouseEvent, id)
              }}
        >{level}</div>
      )
    })
  } else if (contextMenuImpactEntity === 'patent') {  // 3-levels, ['L0', 'L1', 'L2']
    focusedLevelDivElementList = ['L0', 'L1', 'L2'].map((level, index) => {
      return (
        <div key={index} id={`patent-${level}`} className='option-div'
              onClick={(e) => {
                const id = e.currentTarget.id 
                handleMouseOnClick(e as unknown as MouseEvent, id)
              }}
        >{level}</div>
      )
    })
  } else if (contextMenuImpactEntity === 'clinical_trial') {  // L0-L12
    focusedLevelDivElementList = ['L0', 'L1', 'L2', 'L3', 'L4', 'L5', 'L6'].map((level, index) => { // temp, to add to L12
      return (
        <div key={index} id={`clinical_trial-${level}`} className='option-div'
              onClick={(e) => {
                const id = e.currentTarget.id 
                handleMouseOnClick(e as unknown as MouseEvent, id)
              }}
        >{level}</div>
      )
    })
  } else if (contextMenuImpactEntity === 'policy') {    // L0-L4 
    focusedLevelDivElementList = ['L0', 'L1', 'L2', 'L3', 'L4'].map((level, index) => { 
      return (
        <div key={index} id={`policy-${level}`} className='option-div'
              onClick={(e) => {
                const id = e.currentTarget.id 
                handleMouseOnClick(e as unknown as MouseEvent, id)
              }}
        >{level}</div>
      )
    })
  } else if (contextMenuImpactEntity === 'newsfeed') {  // 2-levels: 'Country', 'Outlet or Author'
    focusedLevelDivElementList = ['L0', 'L1'].map((level, index) => { 
      return (
        <div key={index} id={`newsfeed-${level}`} className='option-div'
              onClick={(e) => {
                const id = e.currentTarget.id 
                handleMouseOnClick(e as unknown as MouseEvent, id)
              }}
        >{level}</div>
      )
    })
  }

  return (
    <div className='context-menu-div' style={{
      left: contextMenuPosition.left - 360,
      top: contextMenuPosition.top - 100,
      opacity: contextMenuOpacity,
      zIndex: contextMenuOpacity === 0 ? -10:10,
      width: 164,
    }} >
      <div className='context-menu-header'>Zoom to field level: </div>
      <div className='context-menu-body'>
        {focusedLevelDivElementList}
      </div>
    </div>
  )
}

export default ContextMenu